export default __webpack_public_path__ + "static/media/line1.0b92b448.svg";